var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarshallIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13348f",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d07b2c",
    d: "M30 0 0 24 30 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 12V6L0 24zM9 4l.2 3.43.73-1.89-.33 2 1.2-1.64-.83 1.84 1.57-1.27-1.27 1.57 1.84-.83-1.64 1.18 2-.32-1.9.72L14 9l-3.43.21 1.89.73-2-.33 1.64 1.19-1.84-.83 1.27 1.57-1.57-1.28.83 1.85-1.19-1.64.33 2-.72-1.9L9 14l-.2-3.43-.73 1.89.32-2-1.18 1.64.83-1.85-1.57 1.28 1.28-1.57-1.85.83L7.54 9.6l-2 .33 1.9-.72L4 9l3.43-.2-1.89-.73 2 .32L5.9 7.21l1.85.83-1.28-1.57 1.57 1.28L7.2 5.9l1.18 1.64-.32-2 .72 1.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarshallIslands);
export default __webpack_public_path__ + "static/media/marshall-islands.90754d1d6935943dc0b0b15ee407c0b3.svg";
export { ForwardRef as ReactComponent };